import { render, staticRenderFns } from "./ScrollyMapChapter.vue?vue&type=template&id=7d645440&"
import script from "./ScrollyMapChapter.vue?vue&type=script&lang=js&"
export * from "./ScrollyMapChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports